import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { ModalController } from 'ionic-angular';
import { ToolsProvider } from '../tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { CrudApiProvider } from '../crud-api/crud-api';
import { PostType } from '../posts/posts.types';

const { NewsBrowser } = Plugins;

interface ActionOptions {
  fromBrowser?: boolean;
}

@Injectable()
export class NewsBrowserProvider {
  log = debug('app:NewsBrowserProvider');
  _activeArticle: any;
  _tab = 'latest';

  readArticles: any = {};

  constructor(
    public http: HttpClient,
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public crud: CrudApiProvider
  ) {
    window['_providers'] = window['_providers'] || {};
    window['_providers']['news'] = this;

    if (this.isMobileDevice()) {
      try {
        NewsBrowser.addListener('like', () => {
          if (this._activeArticle) {
            this.onLike(this._activeArticle, {
              fromBrowser: true,
            });
          }
        });

        NewsBrowser.addListener('comments', () => {
          if (this._activeArticle) {
            this.onComments(this._activeArticle, {
              fromBrowser: true,
            });
          }
        });

        NewsBrowser.addListener('share', () => {
          if (this._activeArticle) {
            this.onShare(this._activeArticle, {
              fromBrowser: true,
            });
          }
        });

        NewsBrowser.addListener('track', e => {
          this.track(e);
        });
      } catch (e) {}
    }
  }

  private isMobileDevice() {
    // just only wanna do on phones
    // we dont' even use cordova really but a quick check
    return !!window['cordova'];
  }

  async openArticle(article: PostType) {
    const url =
      // _.get(article, 'articleInformation.ampUrl') || // removing amp articles 09-20-24
      _.get(article, 'articleInformation.linkUrl');

    this.log('opening article', article);

    // just holding in memory for now
    setTimeout(() => {
      this.readArticles[article && article._id] = true;
    }, 1e3);

    if (!url) return;

    this.log('opening url', url);

    this._activeArticle = article;

    const userEngagements = this.tools.userEngagementsOnPost(
      article.userEngagements || []
    );

    this.track('open');
    if (this.isMobileDevice()) {
      return NewsBrowser.open({
        liked: !!userEngagements.liked,
        likes: _.get(article, 'stats.likes'),
        comments: _.get(article, 'stats.comments'),
        url: url + '?utm_medium=inapp',
      }).then(
        d => {
          console.log('done', d);
          return d;
        },
        e => {
          console.log('error', e);
        }
      );
    } else {
      window.open(url, '_blank');
    }
  }

  onLike(article, opts?: ActionOptions) {
    if (article) this._activeArticle = article;
    article = this._activeArticle;

    this.log('TOGGLE LIKE', this._activeArticle);

    const userEngagements = this.tools.userEngagementsOnPost(
      article.userEngagements || []
    );

    if (userEngagements.liked) {
      this.track('like');
      let e;
      article.userEngagements = _.filter(article.userEngagements, d => {
        if (d.engagementType === 'LIKE') e = d;
        return d.engagementType !== 'LIKE';
      });
      article.stats.likes -= 1;
      if (e) {
        this.crud.delete(`/api/engagements/${e._id}`).catch(e => {});
      }
    } else {
      this.track('unlike');
      article.userEngagements.push({
        engagementType: 'LIKE',
        likeInformation: { value: 1 },
        _id: Math.random(),
      });
      article.userEngagements = article.userEngagements.slice();
      article.stats.likes += 1;
      this.crud
        .post('/api/engagements', {
          post: article._id,
          engagementType: 'LIKE',
          likeInformation: { value: 1 },
        })
        .then(
          d => article.userEngagements.push(d.data),
          e => {}
        );
    }
  }

  onComments(article, opts?: ActionOptions) {
    if (article) this._activeArticle = article;

    const modal = this.modalCtrl.create(
      'NewsCommentsPage',
      _.merge({ article: this._activeArticle }, opts),
      {
        cssClass: 'SlideOver',
      }
    );
    modal.present();
    this.track('open-comments');
  }

  onShare(article, opts?: ActionOptions) {
    if (article) this._activeArticle = article;
    this.track('open-share');

    const modal = this.modalCtrl.create(
      'NewsSharePage',
      _.merge({ article: this._activeArticle }, opts),
      {
        cssClass: 'SlideOver',
      }
    );
    modal.present();
    this.track('open-comments');
  }

  private track(e) {
    this.tools.logAnalyticsEvent('trackCustom', 'news-browser-' + e, {
      source: _.get(this._activeArticle, 'user.username'),
      tab: this._tab,
      sourceId: _.get(this._activeArticle, 'user._id'),
    });
  }

  resume() {
    return NewsBrowser.resume();
  }
}



// WEBPACK FOOTER //
// ./src/providers/news-browser/news-browser.ts